import { CreditNote } from '../interfaces/credit-notes/credit-notes.model';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CreditNotesService {

  constructor(private http: HttpClient) {}

  //Get credit notes
  getCreditNotes(): Observable<CreditNote[]> {
    return this.http.get<CreditNote[]>(`/creditNotes`);
  }

  //Get credit notes by client id
  getCreditNotesByClientId(clientId: string, showZeroBalances: boolean): Observable<CreditNote[]> {
    return this.http.get<CreditNote[]>(`/creditNotes?showZeroBalances=${showZeroBalances}&clientId=${clientId}`);
  }

  //Get applied credit notes
  getAppliedCreditNotes(params: any, creditNoteId: string): Observable<any> {
    return this.http.get<any>(`/creditNotes/${creditNoteId}`, { params });
  }

  //Add credit note
  createCreditNote(creditNote: any): Observable<any> {
    return this.http.post<any>(`/creditNotes`, creditNote);
  }

  //Delete credit note
  deleteCreditNote(creditNoteId: string): Observable<any> {
    return this.http.delete<any>(`/creditNotes/${creditNoteId}`);
  }

  applyCreditNote(creditNoteId: string, applyCreditNote: any): Observable<any> {
    return this.http.post<any>(`/creditNotes/${creditNoteId}/apply`, applyCreditNote);
  }

}
